import { render, staticRenderFns } from "./tuijian-xinwen.vue?vue&type=template&id=2e087240&"
import script from "./tuijian-xinwen.vue?vue&type=script&lang=js&"
export * from "./tuijian-xinwen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports